// extracted by mini-css-extract-plugin
export default {"no-breadcrumbs-label":"orphanTeam-module__no-breadcrumbs-label__3vGz1"};